// Polish letters for people without a Polish keyboard: a click types the letter into the box being edited, where the
// cursor is (the button doesn't take the focus, so the box stays active).
import { h, useState } from '../core/react.js';
import { T } from '../core/theme.js';

const LETTERS = 'ąćęłńóśźż';
const textBox = el => el && (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && /^(text|search|email|)$/.test(el.type || ''))) && !el.disabled && !el.readOnly;

// Types ch into el as if from the keyboard, so React's onChange sees it.
export function typeInto(el, ch) {
  const start = el.selectionStart ?? el.value.length, end = el.selectionEnd ?? start;
  const set = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), 'value').set;
  set.call(el, el.value.slice(0, start) + ch + el.value.slice(end));
  el.dispatchEvent(new Event('input', { bubbles: true }));
  try { el.setSelectionRange(start + ch.length, start + ch.length); } catch (_) { /* email boxes have no cursor position */ }
}

export function LetterPad({ style }) {
  const [upper, setUpper] = useState(false);
  const key = { minWidth: 24, height: 24, padding: '0 4px', border: `1px solid ${T.rule}`, background: T.white, color: T.coal, fontSize: 13, cursor: 'pointer', lineHeight: 1 };
  const hold = e => e.preventDefault();   // keep the focus in the box being edited
  const put = ch => { const el = document.activeElement; if (textBox(el)) typeInto(el, ch); };
  return h("div", { role: 'group', 'aria-label': 'Polish letters', title: 'Click in a box, then click a letter to type it', style: { display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'center', ...style } },
    h("span", { style: { fontSize: 10.5, color: T.mist, marginRight: 4 } }, 'Polish letters'),
    [...(upper ? LETTERS.toUpperCase() : LETTERS)].map(ch => h("button", { key: ch, type: 'button', onMouseDown: hold, onClick: () => put(ch), 'aria-label': `Type ${ch}`, style: key }, ch)),
    h("button", { type: 'button', onMouseDown: hold, onClick: () => setUpper(!upper), 'aria-pressed': upper, 'aria-label': 'Capital letters', title: 'Capitals', style: { ...key, background: upper ? T.ivoryD : T.white, fontSize: 11 } }, '⇧'));
}
